/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon20Regular = forwardRef('ArrowCUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.22 13.155a.75.75 0 0 1 0-1.06l4.836-4.836a2.75 2.75 0 0 1 3.889 0l4.836 4.835a.75.75 0 0 1-1.061 1.061L10.884 8.32a1.25 1.25 0 0 0-1.768 0L4.28 13.155a.75.75 0 0 1-1.06 0Z" })));
});
